import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

import { AdminCompany } from "./companies";
import { TeamMember } from "../company/team";
import { AdminPipelineJob } from "./job-pipeline";

export interface AdminCompanyDetails extends AdminCompany {
  team: TeamMember[];
  jobs: AdminPipelineJob[];
}

export const useAdminCompanyDetailsQuery = (companyId = "") => {
  const { getAccessTokenSilently } = useAuth0();

  const {
    data: adminCompanyDetails,
    error: adminCompanyDetailsError,
    isLoading: adminCompanyDetailsLoading,
  } = useQuery({
    queryKey: QueryKeys.adminCompany(companyId),
    enabled: Boolean(companyId),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return request<AdminCompanyDetails>({
        method: "GET",
        path: `/api/admin/companies/${companyId}`,
        token,
      });
    },
  });

  return {
    adminCompanyDetails,
    adminCompanyDetailsError,
    adminCompanyDetailsLoading,
  };
};
